import { RegionShared } from "@1games-ru/region-shared";
import { throttle } from "lodash";
import { useCallback, useEffect, useState } from "react";
import rpc from "@1games-ru/rage-rpc";

export default () => {
  const [vehicle, setVehicle] = useState<
    Required<typeof RegionShared.Cef.Requests.SetVehicleStateRequest>
  >({
    fuel: 0,
    fuelCapacity: 0,
    gear: 0,
    isEngine: false,
    isLocked: false,
    isSeatBelt: false,
    mileage: 0,
    oilTemperature: 0,
    rpm: 0,
    speed: 0,
    isDoors: false,
    isEmergency: false,
    isHandBreak: false,
    isLeftTurn: false,
    isLight: false,
    isRightTurn: false,
  });

  const thrtottleChange = useCallback(
    throttle((args: typeof RegionShared.Cef.Requests.SetVehicleStateRequest) => {
      setVehicle((state) => ({ ...state, ...args }));
    }, 70),
    [],
  );

  useEffect(() => {
    rpc.register(
      RegionShared.Cef.Events.Vehicle.SetVehicleState,
      (args: typeof RegionShared.Cef.Requests.SetVehicleStateRequest): void => {
        thrtottleChange(args);
      },
    );

    return () => {
      rpc.unregister(RegionShared.Cef.Events.Vehicle.SetVehicleState);
    };
  }, []);

  return {
    ...vehicle,
    speed: Math.trunc(vehicle.speed),
    fuel: Math.trunc(vehicle.fuel),
    fuelCapacity: Math.trunc(vehicle.fuelCapacity),
    mileage: Math.trunc(vehicle.mileage),
    rpm: Math.trunc(vehicle.rpm),
    oilTemperature: Math.trunc(vehicle.oilTemperature),
  };
};
